<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        {
          name: 'Investor Relations',
          to: {
            name: 'IR'
          },
        },
         {
          name: 'Detail Page',
          to: {
            name: 'IRFinacialInformationDetailPage'
          },
        },
        {
          name: '新增財務資訊',
          to: {
            name: 'CreateFinancialInformation',
            query: {
              section: $route.query.section,
            },
          },
        },
      ]"
    ></Breadscrumbs>
    <!-- page actions -->
    <div class="page-actions">
      <h2>編輯財務資訊</h2>
      <v-spacer></v-spacer>
      <!-- <button class="btn" @click="editHandler">
        <v-icon class="mr-2">edit</v-icon>
        <span class="mr-2">編輯</span>
      </button> -->
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!--  -->
    <FinancialInformationCreateEdit></FinancialInformationCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import FinancialInformationCreateEdit from '@/views/I_IR/c/IR-Financial Information_CreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    FinancialInformationCreateEdit,
  },
  created() {
    this.setFinancial({
      monthly_revenue: [
        {
          month: 1,
          revenue: '',
          last_revenue: '',
          mom: '',
          current_cumulative_revenue: '',
          last_cumulative_revenue: '',
          yoy: '',
        }, {
          month: 2,
          revenue: '',
          last_revenue: '',
          mom: '',
          current_cumulative_revenue: '',
          last_cumulative_revenue: '',
          yoy: '',
        }, {
          month: 3,
          revenue: '',
          last_revenue: '',
          mom: '',
          current_cumulative_revenue: '',
          last_cumulative_revenue: '',
          yoy: '',
        }, {
          month: 4,
          revenue: '',
          last_revenue: '',
          mom: '',
          current_cumulative_revenue: '',
          last_cumulative_revenue: '',
          yoy: '',
        }, {
          month: 5,
          revenue: '',
          last_revenue: '',
          mom: '',
          current_cumulative_revenue: '',
          last_cumulative_revenue: '',
          yoy: '',
        }, {
          month: 6,
          revenue: '',
          last_revenue: '',
          mom: '',
          current_cumulative_revenue: '',
          last_cumulative_revenue: '',
          yoy: '',
        }, {
          month: 7,
          revenue: '',
          last_revenue: '',
          mom: '',
          current_cumulative_revenue: '',
          last_cumulative_revenue: '',
          yoy: '',
        }, {
          month: 8,
          revenue: '',
          last_revenue: '',
          mom: '',
          current_cumulative_revenue: '',
          last_cumulative_revenue: '',
          yoy: '',
        }, {
          month: 9,
          revenue: '',
          last_revenue: '',
          mom: '',
          current_cumulative_revenue: '',
          last_cumulative_revenue: '',
          yoy: '',
        }, {
          month: 10,
          revenue: '',
          last_revenue: '',
          mom: '',
          current_cumulative_revenue: '',
          last_cumulative_revenue: '',
          yoy: '',
        }, {
          month: 11,
          revenue: '',
          last_revenue: '',
          mom: '',
          current_cumulative_revenue: '',
          last_cumulative_revenue: '',
          yoy: '',
        }, {
          month: 12,
          revenue: '',
          last_revenue: '',
          mom: '',
          current_cumulative_revenue: '',
          last_cumulative_revenue: '',
          yoy: '',
        },
      ],
    });
  },
  computed: {
    ...mapState('financial', ['financial']),
  },
  methods: {
    ...mapActions('financial', ['setFinancial', 'save']),
    cancelHandler() {
      this.$router.push('/investor-relations/detail-page');
    },
    saveHandler() {
      this.save(this.financial).then(() => {
        this.$router.push({ name: 'IRFinacialInformationDetailPage' });
      });
    },
  },
};
</script>

<style></style>
